import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import {
  GridContainer,
  GridRow,
  Button,
  GridColumn,
  Loader,
} from "arv-reactcomponents";
import { Promotions, Checkout } from "npmlinks-constants";
import PromotionsList from "../PromotionsList";

import Analytics, { GTM } from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@inject("CheckoutStore", "PromotionsStore", "LoginStore")
@observer
class ApplicablePromosModal extends Component {
  static triggerPromotionsGa(promo, success, failure) {
    Analytics.trackEvent({
      category: window.pageType,
      action:
        (success && Event.action.PROMO_SUCCESS) ||
        (failure && Event.action.PROMO_FAILURE) ||
        Event.action.PROMO_ATTEMPT,
      label: promo,
    });
  }
  constructor() {
    super();
    this.state = {
      promoErrorMessage: "",
      promoName: "",
      promoFromSelection: "",
    };
    this.init = this.init.bind(this);
    this.handleSubmitButton = this.handleSubmitButton.bind(this);
    this.clearError = this.clearError.bind(this);
    this.setPromo = this.setPromo.bind(this);
  }

  componentDidMount() {
    this.init();
  }
  setPromo(promo, userInput) {
    if (userInput) {
      this.setState({ promoFromSelection: promo, promoName: "" });
    } else {
      this.setState({ promoName: promo, promoFromSelection: "" });
    }
  }
  init(couponCode, donotClearPromotions) {
    if (couponCode) {
      ApplicablePromosModal.triggerPromotionsGa(couponCode);
    }
    const requestBody = {
      ...Checkout.CHECKOUT_BASE_REQUEST,
      type: Checkout.CHECKOUT_API_ACTIONS.READ,
      couponCode: couponCode || null,
      graphProps: {
        ...Checkout.CHECKOUT_BASE_REQUEST.graphProps,
        isApplicablePromotions: true,
      },
    };
    const { isUserLoggedIn } = this.props.LoginStore;
    this.props.CheckoutStore.updateCart(
      requestBody,
      isUserLoggedIn,
      false,
      donotClearPromotions,
    ).then(() => {
      const { pricingOverviewData } = this.props.CheckoutStore;
      const { isCouponApplied, invalidReasonMessage } = pricingOverviewData;
      if (couponCode && isCouponApplied) {
        ApplicablePromosModal.triggerPromotionsGa(couponCode, true);
        GTM.pushWithEvent(
          {
            coupon: couponCode
          },
          Event.GTMEvent.PROMO_SUCCESS);
        this.props.PromotionsStore.setApplicablePromosModal(false);
      }
      if (!isCouponApplied && invalidReasonMessage) {
        ApplicablePromosModal.triggerPromotionsGa(couponCode, false, true);
        GTM.pushWithEvent(
          {
            coupon: couponCode
          },
          Event.GTMEvent.PROMO_FAILURE);
        this.setState({ promoErrorMessage: invalidReasonMessage });
      }
    });
  }
  handleSubmitButton(e) {
    e.preventDefault();
    const { promoFromSelection, promoName } = this.state;
    this.init(promoFromSelection || promoName, true);
  }
  clearError() {
    this.setState({ promoErrorMessage: "" });
  }

  get applicablePromoBtnForDisabled() {
    const { promoFromSelection, promoName } = this.state;
    const { pricingOverviewData: { couponCode } } = this.props.CheckoutStore;
    const localPromo = promoFromSelection || promoName;
    return localPromo && localPromo !== couponCode;
  }

  render() {
    const { promoErrorMessage, promoName, promoFromSelection } = this.state;
    const { loading } = this.props.CheckoutStore;
    return (
      <div className="nw-app-promo-modal">
        <form id="applicable-promo-form">
          <GridContainer className="nw-app-promo-modalcontainer">
            {loading && (
              <GridRow className="nw-applicablepromo-loadercontainer nwc-translucentbackground-white">
                <GridColumn className="nw-applicablepromo-loader">
                  <Loader />
                </GridColumn>
              </GridRow>
            )}
            <GridRow>
              <GridColumn className="nw-applicable-promos-title">
                <span className="nw-applicable-promos-title-span">
                  {Promotions.APPLY_PROMO_TITLE}
                </span>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn>
                <PromotionsList.component
                  appPromos={this.props.CheckoutStore.applicablePromotions}
                  promoErrorMessage={promoErrorMessage}
                  clearError={this.clearError}
                  promoName={promoName}
                  promoFromSelection={promoFromSelection}
                  setPromo={this.setPromo}
                />
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn className="nw-applicable-promos-apply">
                <Button
                  className={`nw-applicable-promos-apply-btn ${
                    this.applicablePromoBtnForDisabled
                  }`}
                  onClick={this.handleSubmitButton}
                  disabled={!this.applicablePromoBtnForDisabled}
                >
                  {Promotions.PROMO_APPLY_BTN}
                </Button>
              </GridColumn>
            </GridRow>
          </GridContainer>
        </form>
      </div>
    );
  }
}

ApplicablePromosModal.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    pricingOverviewData: PropTypes.shape({}).isRequired,
    updateCart: PropTypes.func.isRequired,
    applicablePromotions: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  PromotionsStore: PropTypes.shape({
    setApplicablePromosModal: PropTypes.func.isRequired,
    setSelectedPromo: PropTypes.func.isRequired,
    selectedPromoName: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore", "PromotionsStore", "LoginStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ApplicablePromosModal.wrappedComponent,
  component: ApplicablePromosModal,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Promotions/ApplicablePromosModal/index.js